import actionTypes from "../actions/actionTypes";

const initialState = {
  shotClassData: [],
  programData: [],
  seriesShotclassData: [],
  classAndCollectionDataByID: [],
  organizeContentData: [],
};

const organizeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.organizeTypes.SHOTCLASS_DATA:
      return {
        ...state,
        shotClassData: payload,
      };
    case actionTypes.organizeTypes.PROGRAM_DATA:
      return {
        ...state,
        programData: payload,
      };
    case actionTypes.organizeTypes.SERIES_SHOTCLASS_DATA:
      return {
        ...state,
        seriesShotclassData: payload,
      };
    case actionTypes.organizeTypes.GET_CLASS_COLLECTION_DATA:
      return {
        ...state,
        classAndCollectionDataByID: payload,
      };
    case actionTypes.organizeTypes.CONTENT_DATA:
      return {
        ...state,
        organizeContentData: payload,
      };
    default:
      return state;
  }
};

export default organizeReducer;
